var map = {
	"./realImg.js": 1088
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2645;



//////////////////
// WEBPACK FOOTER
// ./src/directives nonrecursive ^\.\/.*\.js$
// module id = 2645
// module chunks = 115